import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'rmsSafeHtml',
    standalone: false
})
export class RmsSafeHtmlPipe implements PipeTransform {

  constructor (private sanitized: DomSanitizer) {}

  transform(value: any, args?: any): any {
    if (!value) {
      return value;
    }
    return this.sanitized.bypassSecurityTrustHtml(value);
  }

}
